import React from 'react';
import { CheckCircle2, X } from 'lucide-react';

// BulkActionToolbar — sticky bar at the bottom of a list view when ≥1 row is
// selected. Item 1.15b. Each `actions` entry is { key, label, onRun, disabled?,
// hint? }. Parent owns the selection state + the underlying API calls; this
// component is presentational + dispatches onRun(selected).
//
// Renders nothing when no rows are selected.

export default function BulkActionToolbar({ selected = [], actions = [], onClear }) {
  if (!selected || selected.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/[0.08] bg-[#0a0a0f]/95 backdrop-blur-md shadow-[0_10px_40px_-10px_rgba(0,0,0,0.9)]"
      data-testid="bulk-action-toolbar"
    >
      <CheckCircle2 className="w-3.5 h-3.5 text-[#B0FC38]" />
      <span className="text-[12px] text-white">{selected.length} selected</span>
      <div className="w-px h-5 bg-white/[0.08]" />
      {actions.map((a) => (
        <button
          key={a.key}
          type="button"
          onClick={() => a.onRun?.(selected)}
          disabled={a.disabled || a.comingSoon}
          title={a.hint || a.comingSoon ? 'Coming in a future sprint' : undefined}
          data-testid={`bulk-action-${a.key}`}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] border ${a.destructive
            ? 'bg-red-500/15 border-red-500/30 text-red-200 hover:bg-red-500/25'
            : 'bg-white/[0.04] border-white/[0.1] text-gray-200 hover:text-white hover:border-white/[0.2]'} disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {a.label}{a.comingSoon ? ' (soon)' : ''}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onClear?.()}
        aria-label="Clear selection"
        className="ml-1 p-1 rounded-full text-gray-500 hover:text-white"
        data-testid="bulk-action-clear"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
